import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MitsIconModule } from 'src/packages/shared-ui';
import { ChModuleComponent } from '../ch-module/ch-module.component';
import { SortButtonsModule } from './../sort-buttons/sort-buttons.module';
import { ChGroupComponent } from './ch-group.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    MitsIconModule,
    SortButtonsModule,
  ],
  declarations: [ChGroupComponent, ChModuleComponent],
  entryComponents: [ChGroupComponent],
  exports: [ChGroupComponent, ChModuleComponent],
  providers: [],
})
export class ChGroupModule {}
